import * as THREE from 'three/webgpu';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { GameObject, createRigidBody, createBoxCollider, createTrimeshCollider} from './GameObject.js';

// const engine = document.querySelector('game-engine');

export class Floor extends GameObject {
    constructor() {
        super();

        const floorMesh = new THREE.Mesh(
            new THREE.PlaneGeometry( 200, 200 ).rotateX( - Math.PI / 2 ),
            new THREE.MeshBasicNodeMaterial( { color: 'rgba(48, 46, 46, 1)' } )
        )

        const gridHelper = new THREE.GridHelper( 200, 20, 0x111111, 0xcccccc );
        gridHelper.position.y = 0.01;
        floorMesh.add( gridHelper );

        const rigidBody = createRigidBody(
            'fixed',
            [
                createTrimeshCollider(floorMesh.geometry),
            ]
        );

        const link = {
            visual: floorMesh,
            rigidBody,
        }

        this.links.push(link);
    }
}